export default "__VITE_ASSET__967fe400__"